export default "__VITE_ASSET__8df1c01b__"